import cn from "classnames";
import { GridProps } from "./types";
import styles from "./styles.module.scss";

export const Grid = ({ className, children, dataTestId }: GridProps) => (
  <div className={cn(styles.grid, className)} data-test-id={dataTestId}>
    {children}
  </div>
);
